<ng-container *ngIf="compact; else formLayout">
    <input
        [ngClass]="styleClasses"
        [class.is-invalid]="showError"
        [type]="type"
        [id]="inputId"
        [value]="value"
        [disabled]="disabled"
        [placeholder]="placeholder"
        (input)="onInput($event)"
        (blur)="onBlur()" />
</ng-container>

<ng-template #formLayout>
    <div class="mb-3 row">
        <label [attr.for]="inputId" class="col-sm-4 col-form-label">
            {{ label }}
            <sup *ngIf="required" class="text-danger">*</sup>
            <button
                *ngIf="tooltip"
                type="button"
                class="btn btn-outline-success rounded-circle p-0 tooltip-icon-btn ms-1"
                [attr.aria-label]="tooltip"
                (click)="mostrarTooltip()">
                <i class="fas fa-question"></i>
            </button>
        </label>
        <div class="col-sm-8">
            <input
                [type]="type"
                class="form-control"
                [id]="inputId"
                [value]="value"
                [disabled]="disabled"
                [placeholder]="placeholder"
                (input)="onInput($event)"
                (blur)="onBlur()" />
        </div>
        <div *ngIf="showError" class="text-danger">
            {{ requiredError }}
        </div>
    </div>
</ng-template>
